<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">数字医工医疗设备管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          医疗设备的技术应用管理是一个复杂而庞大的系统工程，我国二级以上医院一般都有几千万到几个亿的医疗设备固定资产，数量相当巨大且品种繁多，如何在现有形势与条件下做好高质量的医疗设备技术应用管理，是医疗机构医疗设备管理部门一直面临和困扰的难题。
        </p>
        <p class="content-paragraph">
          近些年国家为保障民众就医需求，对医疗机构的投入大幅增加，尤其在医疗设备投入方面补充显著，医疗设备管理问题迫在眉睫，因此有必要建设以设备为中心、对设备从采购、入库到报废全生命周期中所发生的各种事件进行跟踪的管理平台。在医院智慧管理的要求下，将医疗设备全生命周期管理工作信息化，提高设备生命周期内的利用率，实现安全性与高质量管理，从而达到降低成本、全面提升设备使用效率的目的。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">采购与档案</h3>
            <ul class="capability-list"><li>需求申请</li><li>需求汇总</li><li>创建会议</li><li>会议管理</li><li>招标进度</li><li>设备验收</li><li>档案管理</li><li>报废管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">维修与质控</h3>
            <ul class="capability-list"><li>维修申请</li><li>维修处理</li><li>维修验收</li><li>填单审批</li><li>维修派工（含外派）</li><li>维修超时预警</li><li>维修监控</li><li>巡检管理</li><li>保养管理</li><li>计量管理</li><li>不良事件管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">盘点与共享</h3>
            <ul class="capability-list"><li>盘点记录</li><li>盘点录入</li><li>盘点执行</li><li>全院共享</li><li>我的共享</li><li>我的预约</li><li>我的借出</li><li>我的借入</li><li>归还确认</li><li>转科管理</li><li>借用管理</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/eq-archive.svg"
              alt="海南华德科技有限公司 数字医工医疗设备管理系统 - 设备档案管理 · 一物一档"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>设备档案管理 · 一物一档
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/eq-repair.svg"
              alt="海南华德科技有限公司 数字医工医疗设备管理系统 - 维修管理 · 派工与超时预警"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>维修管理 · 派工与超时预警
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/eq-overview.svg"
              alt="海南华德科技有限公司 数字医工医疗设备管理系统 - 设备资产总览大屏"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>设备资产总览大屏
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/eq-inventory.svg"
              alt="海南华德科技有限公司 数字医工医疗设备管理系统 - 盘点与设备共享"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>盘点与设备共享
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/software13.vue